module.exports = __webpack_public_path__ + "img/story-character-sp.71b09ed0.png";